;$(function() {
	// Maximizer

	function maximizePrevImage() {
		var currentElement = $('.maximizer_current');
		var targetElement;
		if (currentElement.parents('.maximizer-container').prev().length) {
			targetElement = currentElement.parents('.maximizer-container').prev().find('.maximizer');
		} else {
			var itemList = currentElement.parents('.maximizer-gallery').find('.maximizer-container');
			targetElement = itemList.last().find('.maximizer');
		}
		var imageSrc = targetElement.find('.maximizer__image').attr('src');
		$('.maximizer__new-image').attr('src', imageSrc);
		currentElement.removeClass('maximizer_current');
		targetElement.addClass('maximizer_current');
	}

	function maximizeNextImage() {
		var currentElement = $('.maximizer_current');
		var targetElement;
		if (currentElement.parents('.maximizer-container').next().length) {
			targetElement = currentElement.parents('.maximizer-container').next().find('.maximizer');
		} else {
			var itemList = currentElement.parents('.maximizer-gallery').find('.maximizer-container');
			targetElement = itemList.first().find('.maximizer');
		}
		var imageSrc = targetElement.find('.maximizer__image').attr('src');
		$('.maximizer__new-image').attr('src', imageSrc);
		currentElement.removeClass('maximizer_current');
		targetElement.addClass('maximizer_current');
	}

	function closeMaximizer() {
		$('.maximizer_current').removeClass('maximizer_current');
		$('.pop-up-shadow').animate({
			opacity: 0
		}, 400, function() {
			$('.pop-up-shadow').removeClass('pop-up-shadow_opened');
		});
		$(window).off('keyup', switchMaximizedImageByKey);
	}

	function switchMaximizedImageByKey(e) {
		switch (e.which) {
			// Right button
			case 39:
				maximizeNextImage();
				break;
			// Left button
			case 37:
				maximizePrevImage();
				break;
			// Escape
			case 27:
				closeMaximizer();
				break;
		}
	};

	// $('.pop-up-shadow').hide();

	$('.maximizer').click(function(index) {
		$(this).blur();
		var imageSrc = $(this).find('.maximizer__image').attr('src');
		$('.maximizer__new-image').attr('src', imageSrc);
		$(this).addClass('maximizer_current');
		$('.pop-up-shadow').addClass('pop-up-shadow_opened');
		$('.pop-up-shadow').animate({
			opacity: 1
		}, 400, function() {});
		$(window).on('keyup', switchMaximizedImageByKey);
	});

	$('.maximizer__close-button').click(closeMaximizer);

	$('.pop-up-shadow').click(closeMaximizer);

	$('.maximizer__box').click(function(e) {
		e.stopPropagation();
	});

	$('.maximizer__button_prev').click(function(e) {
		e.stopPropagation();
		maximizePrevImage();
	});

	$('.maximizer__button_next').click(function(e) {
		e.stopPropagation();
		maximizeNextImage();
	});

	$('.maximizer_square').each(function() {
		$(this).css('height', $(this).outerWidth() + 'px');
	});
});